import gql from "graphql-tag"

const DELETE_GALLERY_TEXT_ITEM = gql`
mutation DeleteGalleryTextItem($id: ID!) {
    deleteGalleryTextItem(galleryTextItemId:$id)
}
`
export default DELETE_GALLERY_TEXT_ITEM
